import { ROUTER_NAMES } from "@/constants/router.constants"
import store from "@/store/index.store"
import { LoginLayout, MainLayout } from "@/layouts"

const InstacoachMarketing = () =>
  import(
    /* webpackChunkName: "coaching" */ "@/pages/marketing/InstacoachMarketing"
  )
const InstacoachApplication = () =>
  import(
    /* webpackChunkName: "coaching" */ "@/pages/instacoach/InstacoachApplication"
  )
const Coaches = () =>
  import(/* webpackChunkName: "coaches" */ "@/pages/Coaches")
const CoachProfile = () =>
  import(/* webpackChunkName: "coaches" */ "@/pages/CoachProfile")

export default [
  {
    path: "/instapro",
    name: ROUTER_NAMES.BECOME_COACH,
    component: InstacoachMarketing,
    meta: {
      layout: {
        component: LoginLayout,
      },
    },
    beforeEnter: (to, from, next) => {
      Promise.all([
        store.dispatch("Games/loadGames"),
        store.dispatch("Coaching/loadInstaProGames"),
      ]).then(() => {
        next()
      })
    },
  },
  {
    path: "/instapro/apply",
    name: ROUTER_NAMES.COACH_APPLICATION,
    component: InstacoachApplication,
    meta: {
      layout: {
        component: LoginLayout,
      },
    },
  },
  {
    path: "/coaches/:game?",
    name: ROUTER_NAMES.COACHES,
    component: Coaches,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
    children: [
      {
        path: "gameplay-analysis",
        component: Coaches,
        meta: {
          settings: {
            startGpaFlow: true,
          },
        },
      },
    ],
    beforeEnter: async (_to, from, next) => {
      try {
        // If no game is provided, direct user to their currently set active game
        const game = _to.params.game
        if (!game) {
          try {
            await store.dispatch("User/loadUser")
            await store.dispatch("User/loadUserActiveGames")
          } catch (error) {}
          const currentActiveGame =
            store.getters["User/currentActiveGame"] || "leagueoflegends"
          return next({
            name: ROUTER_NAMES.COACHES,
            query: _to.query,
            params: {
              game: currentActiveGame,
            },
          })
        }

        try {
          await Promise.all([
            store.dispatch("User/loadUser"),
            store.dispatch("Games/loadGames"),
            store.dispatch("Game/fetchInstaproGames"),
          ])
          await store.dispatch("User/Coaching/loadInstaProUser")
        } catch (error) {}
        const isGameAvailable = store.getters["Games/getGameByKey"](game)
        if (isGameAvailable) {
          store.dispatch("User/setUserActiveGame", game)
          const instaproGame = (store.getters["Game/availableInstaproGamesMap"] || {})[game] || null
          store.dispatch("Instapro/Vod/setGame", instaproGame)
          return next()
        } else {
          return next("/404")
        }
      } catch (error) {
        console.error(error)
        return next()
      }
    },
  },
  {
    path: "/coach/:username/:game?",
    name: ROUTER_NAMES.COACH_PROFILE,
    component: CoachProfile,
    meta: {
      layout: {
        component: MainLayout,
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/coaching.routes.js